<onsip-header-main>
  <onsip-header-page-title>Phones</onsip-header-page-title>
</onsip-header-main>
<onsip-loading-container [deferCond]="isDataObtained$">
  @if (hasPhones | async) {
  <onsip-header-main>
    <onsip-header-action-bar>
      <mat-form-field appearance="outline">
        <input matInput [formControl]="search" placeholder="Search" autocomplete="off" />
        <mat-icon matSuffix color="primary">search</mat-icon>
      </mat-form-field>
      <button
        mat-stroked-button
        onsip-header-secondary-action
        color="primary"
        [routerLink]="views.PHONE_SETUP"
        id="onsip--admin-phones--add-phone-button"
      >
        Add a phone
      </button>
      <div onsip-header-secondary-action>
        <button
          [disabled]="!(dataSource.data && dataSource.data.length)"
          mat-stroked-button
          color="primary"
          type="button"
          (click)="onExportCsv()"
        >
          Export CSV
        </button>
      </div>
    </onsip-header-action-bar>
  </onsip-header-main>
  <onsip-table-two
    class="onsip-admin-phones-table"
    multiTemplateDataRows
    matSort
    [dataSource]="dataSource"
    [trackBy]="trackByMacAddress"
    [useGrid]="true"
    [hoverable]="true"
  >
    <!-- Mac Address Column -->
    <ng-container matColumnDef="macAddress">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="span-with-icon">
        <span>mac address</span>
        <mat-icon
          class="question-hover-icon"
          onsip-question-mark-tooltip
          matTooltipClass="onsip-tooltip-background"
          matTooltip="A MAC address uniquely identifies a phone’s network. The address is typically labeled on the back of the phone."
          matTooltipPosition="above"
        >
          help_outline
        </mat-icon>
      </mat-header-cell>
      <mat-cell *matCellDef="let phone">
        {{ phone.macAddress | macAddress }}
      </mat-cell>
    </ng-container>
    <!-- Line 1 Column -->
    <ng-container matColumnDef="line">
      <mat-header-cell *matHeaderCellDef mat-sort-header>line 1</mat-header-cell>
      <mat-cell *matCellDef="let phone">
        {{ phone.line1 }}
      </mat-cell>
    </ng-container>
    <!-- Make & Model Column -->
    <ng-container matColumnDef="make">
      <mat-header-cell *matHeaderCellDef mat-sort-header>make & model</mat-header-cell>
      <mat-cell *matCellDef="let phone">
        {{ phone.model }}
      </mat-cell>
    </ng-container>
    <!-- Provision status Column -->
    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef mat-sort-header>provision status</mat-header-cell>
      <mat-cell *matCellDef="let phone">
        {{ phone.encryptionKey ? "Provisioned" : "Not Provisioned" }}
      </mat-cell>
    </ng-container>
    <!-- Action Column -->
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let phone">
        @if (selectedRows.includes(phone.phoneId)) {
        <mat-icon color="primary" class="expansion-arrow">expand_less</mat-icon>
        } @if (!selectedRows.includes(phone.phoneId)) {
        <mat-icon color="primary" class="expansion-arrow">expand_more</mat-icon>
        }
        <div>
          <button mat-icon-button (click)="removeItem(phone, $event)" color="primary">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>
    <!-- Expanded -->
    <ng-container matColumnDef="expanded">
      <onsip-table-shelf-cell
        *matCellDef="let phone"
        [attr.colspan]="displayedColumns.length"
        [expanded]="selectedRows.includes(phone.phoneId)"
      >
        @if (selectedRows.includes(phone.phoneId)) {
        <onsip-phone-detail [phoneInfo]="phone"></onsip-phone-detail>
        }
      </onsip-table-shelf-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="
        selectedRows.includes(row.phoneId)
          ? selectedRows.splice(selectedRows.indexOf(row.phoneId), 1)
          : selectedRows.push(row.phoneId)
      "
    ></mat-row>
    <onsip-table-shelf *matRowDef="let row; columns: ['expanded']"></onsip-table-shelf>
    <div *matNoDataRow class="no-data-row">
      @if (!dataSource.data.length || !search.value) {
      <span translate [translateParams]="{ value: 'ONSIP_I18N.PHONES' | translate }">
        ONSIP_I18N.YOU_HAVENT_ADDED_ANY_VALUE_YET
      </span>
      } @if (search.value && dataSource.data.length) {
      <span>
        {{ "ONSIP_I18N.NO_RESULTS" | translate }}
      </span>
      }
    </div>
  </onsip-table-two>
  <mat-paginator
    onsip-paginator-primary-icon
    showFirstLastButtons
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
  >
  </mat-paginator>
  @if (isAccountAdmin) {
  <div class="busy-lamp-field">
    <span class="mat-body-1 span-with-icon">
      Enable Busy Lamp Field
      <mat-icon
        class="question-hover-icon"
        onsip-question-mark-tooltip
        matTooltipClass="onsip-tooltip-background"
        matTooltip="Busy Lamp Field is a light on a phone’s display that indicates which lines are in use. This service applies to all phones on your PBX that support the feature."
        matTooltipPosition="above"
      >
        help_outline
      </mat-icon>
    </span>
    <div class="mat-body-2">{{ getPricingText() }}</div>
    <span class="blf-slide-toggle">
      <mat-slide-toggle
        color="primary"
        [formControl]="blf"
        (change)="toggleBLF($event)"
      ></mat-slide-toggle>
    </span>
  </div>
  } } @else {
  <onsip-phones-empty-data (addNewPhone)="addNewPhone()"></onsip-phones-empty-data>
  }
  <span class="mat-body-2 contact-support"
    >{{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
    <a class="support-link" [routerLink]="views.CONTACT_SUPPORT">
      {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
    </a>
  </span>
</onsip-loading-container>
